import React from 'react';

import useSiteMetadata from '../hooks/use-site-metadata';


type Props = {
  title?: string,
  description?: string,
  privatePage?: boolean,
};


const SEO = ({title, description, privatePage}: Props) => {
  const data = useSiteMetadata();

  if (privatePage) {
    return (
      <>
        <title>{title || data.site.siteMetadata.title}</title>
        <meta name="robots" content="noindex, nofollow"/>
      </>
    );
  }

  return (
    <>
      <title>{title || data.site.siteMetadata.title}</title>
      <meta name="author" content={data.site.siteMetadata.author}/>
      {description && <meta name="description" content={description}/>}
      <meta name="keywords" content="sethness-roquette, caramels de spécialité, specialty caramels, colorant caramel, caramel color, caramel de spécialité, caramel au beurre salé, salted butter caramel, caramel sauce, caramel flakes, éclats de caramel, burnt sugar, caramel ingrédient, caramel industriel"/>
    </>
  );
};


export default SEO;
